import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import './ContactMessageField.scss';

const ContactMessageField = ({
  input,
  meta: {
    active,
    touched,
    error,
  },
}) => (
  <div
    className={cx(
      'contact-message-field',
      { 'contact-message-field--error': (touched && error) }
    )}
  >
    <textarea
      {...input}
      className="contact-message-field__input"
    />
    {(!active && (!input.value || !touched)) && (
      <label
        className="contact-message-field__label"
        htmlFor={input.name}
      >
        Message
      </label>
    )}
  </div>
);

ContactMessageField.propTypes = {
  input: PropTypes.object,
  meta: PropTypes.shape({
    active: PropTypes.bool,
    touched: PropTypes.bool,
    error: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.string),
      PropTypes.string,
    ]),
  }),
};

ContactMessageField.defaultProps = {
  input: {},
  meta: {
    touched: false,
    error: [],
  },
};

export default ContactMessageField;



// WEBPACK FOOTER //
// ./src/routes/Contact/components/ContactMessageField/ContactMessageField.js